__turbopack_context__.v({
  "article": "s_sSwq_article",
  "desc": "s_sSwq_desc",
  "excerpt": "s_sSwq_excerpt",
  "img-container": "s_sSwq_img-container",
  "loading": "s_sSwq_loading",
  "photo": "s_sSwq_photo",
  "post-title": "s_sSwq_post-title",
  "read-more": "s_sSwq_read-more",
  "shine": "s_sSwq_shine",
  "text": "s_sSwq_text",
  "title": "s_sSwq_title",
});
